var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ValidatorConstraint } from "class-validator";
const DANGEROUS_PROTOCOLS = new Set([
    "javascript:",
    "data:",
    "vbscript:",
    "blob:",
]);
let IsValidRedirectUrlConstraint = class IsValidRedirectUrlConstraint {
    validate(value) {
        if (!value || typeof value !== "string") {
            return false;
        }
        try {
            const url = new URL(value);
            const protocol = url.protocol.toLowerCase();
            if (DANGEROUS_PROTOCOLS.has(protocol)) {
                return false;
            }
            if (protocol === "http:" || protocol === "https:") {
                return url.hostname.length > 0;
            }
            return value.includes("://") && url.href.length > protocol.length + 2;
        }
        catch {
            return false;
        }
    }
    defaultMessage(_args) {
        return "Each redirect URL must be a valid URL (e.g., https://example.com/callback or myapp://callback)";
    }
};
IsValidRedirectUrlConstraint = __decorate([
    ValidatorConstraint({ name: "IsValidRedirectUrl", async: false })
], IsValidRedirectUrlConstraint);
export { IsValidRedirectUrlConstraint };
